// Dropdown field validator - must pass custom Error whenever this field is mandatory

export default ({ mandatory = false, customError = null }) => ({
  presence: mandatory && { message: customError && `^${customError}` }
});
